var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1112,
    height: 284,
    viewBox: "0 0 1112 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2655_22536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1084.91 0.519531H13.9017V1.63939L13.728 284.068H1099.42V13.1353L1084.91 0.519531ZM1098.5 283.151H14.6462L14.8199 1.63939V1.43623H1083.99L1098.5 14V283.151Z",
    fill: "#2B6AE6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 187.442V271.88L8.66533 272.049V178.037L0 187.442Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 143.975V183.071L8.66533 173.919V134.57L0 143.975Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 135.491V140.778L8.66533 131.626V126.086L0 135.491Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 125.794V131.081L8.66533 121.929V116.389L0 125.794Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 116.097V121.384L8.66533 112.232V106.697L0 116.097Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 106.405V111.692L8.66533 102.54V97L0 106.405Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.17 237.468V274.342L1100.08 274.11V224.352L1112.17 237.468Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.17 225.636V233.009L1100.08 220.245V212.52L1112.17 225.636Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.17 212.108V219.487L1100.08 206.717V198.992L1112.17 212.108Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.17 198.585V205.958L1100.08 193.194V185.469L1112.17 198.585Z",
    fill: "#156DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.17 185.058V192.436L1100.08 179.666V171.941L1112.17 185.058Z",
    fill: "#156DF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2655_22536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1112,
    height: 284,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFrame);
export default __webpack_public_path__ + "static/media/table-frame.1c6d533668a1194a950ee782aef538c9.svg";
export { ForwardRef as ReactComponent };